import { Survey } from '@rossum/api-client/surveys';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { boldText, white } from '../../../../lib/formaterValues';
import { userSelector } from '../../../../redux/modules/user/selectors';
import DialogTitle from '../../../../ui/dialog-title/DialogTitle';
import { DiscoveryCall } from '../discoveryCallsList';
import { useSurveyActions } from '../hooks/useSurveyActions';

export type DiscoveryCallSurveyDialogProps = {
  survey: Survey;
  open: boolean;
  discoveryCall: DiscoveryCall;
  calendlyLink: string;
};

export const DiscoveryCallSurveyDialog = ({
  survey,
  open,
  discoveryCall,
  calendlyLink,
}: DiscoveryCallSurveyDialogProps) => {
  const intl = useIntl();
  const surveyPlacement = discoveryCall.featureFlagSlug;

  const { increaseSkipCount, answer } = useSurveyActions(
    survey,
    surveyPlacement
  );

  const handleSkip = () => {
    increaseSkipCount().catch(() => {});
  };

  const user = useSelector(userSelector);

  const handleSubmit = () => {
    answer([{ value: user.email }]).then(() => {
      window.open(calendlyLink, '_blank', 'noopener,noreferrer');
    });
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        elevation: 2,
        sx: {
          width: 490,
        },
      }}
    >
      <DialogTitle
        title={intl.formatMessage({
          id: `components.surveys.dataCaptureSurvey.questions.researchCall.discoveryCall.title`,
        })}
      />

      <DialogContent>
        <Stack sx={{ pt: 2 }} spacing={2}>
          <Typography variant="body2">
            {intl.formatMessage(
              {
                id: 'components.surveys.dataCaptureSurvey.questions.researchCall.text_1',
              },
              { boldText, whiteText: white }
            )}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {intl.formatMessage({
              id: 'components.surveys.dataCaptureSurvey.questions.researchCall.text_2',
            })}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleSkip}
            data-cy={`discovery-call-${surveyPlacement}-skip`}
          >
            {intl.formatMessage({
              id: 'components.surveys.dataCaptureSurvey.questions.researchCall.discoveryCall.noThanks',
            })}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            data-cy={`discovery-call-${surveyPlacement}-submit`}
          >
            {intl.formatMessage({
              id: 'components.surveys.dataCaptureSurvey.questions.researchCall.discoveryCall.yesTalk',
            })}
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
};
